import React from 'react'
// import logo from './logo.svg'

import './App.css'
import './Home.css'

function Home () {
  return (
    <div className="Home">
      <section className="hero">
        <h1 className="hero-title">Commandforge</h1>
        <p className="hero-description">
          Easily create commands that extract knowledge or decisions from an LLM in a programmatically useful way!
        </p>
        <p className="hero-description">
          Then, import them directly into your Ruby or TypeScript code!
        </p>
      </section>
    </div>
  )
}

export default Home
